export enum ProcessErrors {
	ADF_CONVERSION_ERROR = 'AdfConversionError',
	PROCESS_IMAGE_ERROR = 'ProcessImageError',
}
